module.exports = __webpack_public_path__ + "assets/07256f4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sale.jpg
// module id = 105
// module chunks = 0